/**
 * @file    useEngineRender.ts
 * @scope   SHARED
 * @summary Binds the registry render resolver to the engine flag resolver for the dashboard.
 * @consumes resolveEngineRender, useFeatureFlagResolver
 * @produces useEngineRender
 * @sideEffects None.
 * @notes   Phase 6. Memoized per config/flags so the renderer gets a stable resolution.
 */
import { useMemo } from 'react';
import { useFeatureFlagResolver } from '../engine/featureFlags/useFeatureFlagResolver';
import { resolveEngineRender } from './engineChartTypeRegistry';

/**
 * @param config Persisted widget config.
 * @param isEngine Family check (`isDiyWidgetEngine`).
 */
export const useEngineRender = (config: unknown, isEngine: boolean) => {
  const isFlagEnabled = useFeatureFlagResolver();
  return useMemo(
    () => resolveEngineRender(config, { isEngine, isFlagEnabled }),
    [config, isEngine, isFlagEnabled]
  );
};
